export default "__VITE_ASSET__CG4EZqUe__"